import gql from 'graphql-tag';
import { useCustomQuery } from '../../../logic/api/graphQL/useCustomQuery';
import { CurrentUserGq, CurrentUserGqProps } from '../models/CurrentUserGq';
import { PagingResultGq } from '../models/PagingResultGq';
import { PagingInputGq } from '../models/PagingInputGq';

export function useGetTeamUsersGq(command: CommandGq) {
  const query = useCustomQuery<GQLData, GQLVariables>(gqTag, {
    variables: { command: command },
  });

  const data = query.data?.users?.getTeamUsers ?? query.previousData?.users?.getTeamUsers;
  return {
    query,
    users: data?.users ?? null,
    paging: data?.pagingResult ?? null,
  };
}

const gqTag = gql`
  query GetTeamUsers($command: GetTeamUsersCommand!) {
    users {
      getTeamUsers(command: $command) {
          users {
            ${CurrentUserGqProps}
          }
          pagingResult { ${PagingResultGq} }
        }
      }
  }
`;

interface GQLData {
  readonly users: {
    readonly getTeamUsers: {
      readonly users: CurrentUserGq[];
      readonly pagingResult: PagingResultGq;
    };
  };
}

export interface GQLVariables {
  command: CommandGq;
}

export interface CommandGq {
  pagingInput: PagingInputGq;
  searchTerm?: string;
  members?: boolean;
  pending?: boolean;
  removed?: boolean;
}
